/* eslint-disable @typescript-eslint/naming-convention */
// ---------------------------------------------------------------------------
// localStorage keys
// ---------------------------------------------------------------------------
const AI_TOKEN_KEY = 'ai_chat_token';
const AI_TOKEN_EXPIRES_AT_KEY = 'ai_chat_token_expires_at';
// ---------------------------------------------------------------------------
// Token helpers
// ---------------------------------------------------------------------------
export function getStoredAiToken() {
    try {
        return localStorage.getItem(AI_TOKEN_KEY);
    }
    catch (_a) {
        return null;
    }
}
export function setStoredAiToken(token, expiresAt) {
    try {
        if (token) {
            localStorage.setItem(AI_TOKEN_KEY, token);
            if (expiresAt)
                localStorage.setItem(AI_TOKEN_EXPIRES_AT_KEY, expiresAt);
        }
        else {
            localStorage.removeItem(AI_TOKEN_KEY);
            localStorage.removeItem(AI_TOKEN_EXPIRES_AT_KEY);
        }
    }
    catch (error) {
        console.warn('[aiTokenStorage] Failed to persist AI token:', error);
    }
}
export function getStoredAiTokenExpiresAt() {
    try {
        return localStorage.getItem(AI_TOKEN_EXPIRES_AT_KEY);
    }
    catch (_a) {
        return null;
    }
}
